import { ADDRESS_REQUIREMENTS_BY_COUNTRY, ALL_COUNTRIES, PROVINCES_BY_CITY, CITIES_BY_COUNTRY, PROVINCES_BY_COUNTRY, SUPPORTED_COUNTRIES, } from '../types/address';
export * from './addressHelpers/deprecated';
export const getCountriesForRegion = (region) => {
    return SUPPORTED_COUNTRIES.filter((country) => country.region === region);
};
export const getCitiesForCountry = (country) => {
    return CITIES_BY_COUNTRY[country] ?? [];
};
export const getProvincesForCity = (country, city) => {
    return PROVINCES_BY_CITY[country]?.[city] ?? [];
};
export const getProvincesForCountry = (country) => {
    return PROVINCES_BY_COUNTRY[country] ?? [];
};
export const getProvinceNameFromCode = (countryCode2, provinceCode) => {
    const provinceName = PROVINCES_BY_COUNTRY[countryCode2]?.find((province) => province.code === provinceCode)?.name;
    return provinceName ?? provinceCode;
};
export const getProvinceCodeFromName = (countryCode2, provinceName) => {
    const provinceCode = PROVINCES_BY_COUNTRY[countryCode2]?.find((province) => province.name === provinceName)?.code;
    return provinceCode ?? provinceName;
};
export const getAddressRequirementsForCountry = (country, orderTotalsRequireAddressID = true) => {
    // orderTotalsRequireAddressID is decided based on order total alone (SA requirements, default true)
    let addressRequirements = ADDRESS_REQUIREMENTS_BY_COUNTRY[country] ?? [];
    if (country === 'SA' && !orderTotalsRequireAddressID) {
        addressRequirements = addressRequirements.filter((item) => {
            return item.type !== 'identification_number';
        });
    }
    return addressRequirements;
};
export const modifyAddressForCountry = (address) => {
    if (address?.country === 'QA') {
        return {
            ...address,
            line2: `${(address.line2 || '').trim()} ${(address.line3 || '').trim()}`.trim(),
            line3: undefined,
        };
    }
    return address;
};
/**
 * Validates a single field of a user-entered address.
 * Use react-hook-form's register to do this validation instead if possible.
 * @param field Address field / requirements
 * @param input User inputted value
 * @returns If the field passed all validations or if not, what validation failed
 */
export const validateAddressInput = (field, input) => {
    if (!input) {
        return field.required
            ? { isValid: false, errorType: 'required' }
            : { isValid: true };
    }
    if (field.pattern && !field.pattern.exec(input)) {
        return { isValid: false, errorType: 'pattern' };
    }
    if (field.minLength && input.length < field.minLength) {
        return { isValid: false, errorType: 'minLength' };
    }
    if (field.maxLength && input.length > field.maxLength) {
        return { isValid: false, errorType: 'maxLength' };
    }
    return { isValid: true };
};
export const getAddressFieldValidationRequirements = (field) => {
    return {
        required: field.required,
        minLength: field.minLength,
        maxLength: field.maxLength,
        pattern: field.pattern,
    };
};
export const getAddressFieldErrorKey = (field, errorType) => {
    if (errorType === 'maxLength')
        return 'maxLengthError';
    return `validityError${field.example ? 'WithExample' : ''}`;
};
export const getAlpha3FromAlpha2 = (alpha2) => {
    return (ALL_COUNTRIES.find((country) => country.alpha2 === alpha2)?.alpha3 ?? '');
};
export const getAlpha2FromAlpha3 = (alpha3) => {
    return (ALL_COUNTRIES.find((country) => country.alpha3 === alpha3)?.alpha2 ?? '');
};
export const getPhoneCountryCode = (alpha2) => {
    const country = ALL_COUNTRIES.find((country) => country.alpha2 === alpha2);
    return country?.phoneCountryCode ? `+${country.phoneCountryCode}` : '';
};
export const getPhoneCountryCodes = (countries = ALL_COUNTRIES) => {
    return countries
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((country) => {
        const phoneCountryCode = country.phoneCountryCode ?? '';
        return {
            label: `+${phoneCountryCode} ${country.alpha2}`,
            value: `+${phoneCountryCode}`,
        };
    });
};
